import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { DataService } from '../../../services/data.service';
import { Item } from '../../../POS/models/item';
import { Category } from '../../../POS/models/category';
import{Customer} from '../../../POS/models/customer';
import { OrderPayment } from '../../../POS/models/order-payment';
import { CommonFunctionService, UserMerchantData, UserPOSData} from '../../../services/Common/common-function.service';
import { TaxesFeeSetup } from '../../../POS/models/taxes-fee-setup';
import{OrderMaster} from '../../../POS/models/order-master';
import { catchError, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ItemServiceService {
  userId: any;
  token;
  headers: any;
  constructor(private service: DataService, private http: HttpClient,private common:CommonFunctionService) { 
    let loggedUsername =this.common.getUserName()
    this.token =environment.GetAuthenticationToken + ":" +this.common.GetAuthToken()+ ":" + "IT"+ ":"+environment.GetAuthencticationKey+":"+this.common.getSid();
    this.headers = new HttpHeaders().
    set('Authorization', 'basic ' + btoa(this.token));
  }
  
  AddItem(data)
  {
    this.GetGeaderdetails();
   // return this.service.create(environment.AddItemUrl, data);
   return this.http.post<any>(environment.AddItemUrl, data,{headers:this.headers});
  }

  UpdateItem(data) {
    this.GetGeaderdetails();
    // return this.service.put(
    //   environment.UpdateItemUrl + "?PosSubscriptionId=" + data.PosSubscriptionId+"&id="+data.ItemId,data );
    return this.http.post<any>( environment.UpdateItemUrl,data ,{headers:this.headers});
    
  }
  GetItemDetail(data) {
    // this.GetGeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();

    let loggedUsername =this.common.getUserName()
    this.token =environment.GetAuthenticationToken + ":" +this.common.GetAuthToken()+ ":" + "IT"+ ":"+environment.GetAuthencticationKey+":"+this.common.getSid()+ ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
    set('Authorization', 'basic ' + btoa(this.token));

    return this.http.get<any>(environment.GetItemDetailUrl + "?PosSubscriptionId=" + data.PosSubscriptionId+"&id="+data.id,{headers:this.headers})
    .pipe(map(response => response))  ;
   
  
  }
  
  AddItemCategory(data)
  {
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();

    let loggedUsername =this.common.getUserName()
    this.token =environment.GetAuthenticationToken + ":" +this.common.GetAuthToken()+ ":" + "IT"+ ":"+environment.GetAuthencticationKey+":"+this.common.getSid()+ ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
    set('Authorization', 'basic ' + btoa(this.token));

    
    return this.http.post(environment.AddItemCategoryUrl, data,{headers:this.headers});
  }

  UpdateItemCategory(data) {
    this.GetGeaderdetails();
    // return this.service.put(
    //   environment.UpdateItemCategoryUrl + "?PosSubscriptionId=" + data.PosSubscriptionId+"&id="+data.ItemCategoryId,data );
    return this.http.post(
      environment.UpdateItemCategoryUrl,data ,{headers:this.headers});
  }
  GetOrderdetails(data) {
    this.GetGeaderdetails();
    return this.http.get<any>(environment.Getorderdetails + "?PosSubscriptionId=" + data.PosSubscriptionId+"&id="+data.id,{headers:this.headers})  
    .pipe(map(response => response))
  .pipe(catchError(this.common.handleError));
  
}

  CashPayment(data)
  {
    this.GetGeaderdetails();
    return this.http.post(environment.CashTransaction, data,{headers:this.headers});
  }
  NewOrder(data)
  {
    this.GetGeaderdetails();
    return this.http.post<any>(environment.AddOrders, data,{headers:this.headers});

  }


orderidcancelation(data) {
  this.GetGeaderdetails();
  return this.http.get<OrderMaster>(environment.Ordercancelation + "?PosSubscriptionId=" + data.PosSubscriptionId+"&id="+data.id+"&OrderID="+data.OrderId,{headers:this.headers})
  .pipe(map(response => response))
}

getCoupondetails(data,CouponCode)
{
  this.GetGeaderdetails();
  return this.http.post<any>(environment.getCoupondetails+ "?CouponCode=" + CouponCode,data,{headers:this.headers})
  .pipe(map(response => response))
}

  AddCustomer(data)
  {
    this.GetGeaderdetails();
    return this.http.post(environment.AddCustomerUrl, data,{headers:this.headers});
  }
    
  GetCustomerIDDetail(data) {
    this.GetGeaderdetails();
    return this.http.get<Customer>(environment.GetCustomerIDDetail + "?PosSubscriptionId=" + data.PosSubscriptionId+"&id="+data.id,{headers:this.headers})
    .pipe(map(response => response))  ;
  }
  EmailOrder(OrderId) {
    return this.http.get<OrderPayment>(environment.EmailMobileOrder +"?OrderId="+OrderId,{headers:this.headers})
    .pipe(map(response => response))    
    .pipe(catchError(this.common.handleError));
    
  }

  GetCustomerid(data) {
    this.GetGeaderdetails();
    return this.http.get<any>(environment.GetCustomerEmailDetail + "?PosSubscriptionId=" + data.PosSubscriptionId+"&email="+data.Email +"&Mobilenumber="+data.MobileNumber,{headers:this.headers})
    .pipe(map(response => response))
  }
  GetCategoryTaxFeeList(data)
  {
    this.GetGeaderdetails();
    return this.http.get<any[]>(environment.GetCategoryTaxFeeListUrl + "?PosSubscriptionId=" + data.PosSubscriptionId,{headers:this.headers})
    .pipe(map(response => response))  ;
  }
  GetItemCategoryDetail(data) {
    this.GetGeaderdetails();
    return this.http.get<any>(environment.GetItemCategoryDetailUrl + "?PosSubscriptionId=" + data.PosSubscriptionId+"&id="+data.id,{headers:this.headers})
    .pipe(map(response => response))  ;
  }
  GetCategoryName(data) {
    return this.http.get<any>(environment.GetCategoryNameDetailUrl + "?PosSubscriptionId=" + data.PosSubscriptionId+"&Name="+data.CategoryName,{headers:this.headers})
    .pipe(map(response => response))
      
  }
  InsertItem(id,PosSubscriptionId,data) {
    this.GetGeaderdetails();
    return this.http.post(environment.ItemFileUplod + "?PosSubscriptionId=" + PosSubscriptionId+"&Id="+id,data,{headers:this.headers})  
    .pipe(map(response => response))    
    .pipe(catchError(this.common.handleError));
  
  }
  GetDuplicateProductCode(data)
  {
    this.GetGeaderdetails();
    return this.http.get<any>(environment.GetDuplicateProductCodeUrl + "?Productcode=" + data.ProductCode+"&Possubscriptionid="+data.PosSubscriptionId,{headers:this.headers})
    .pipe(map(response => response))    ;
  
   
  }
  GetItemCategoryListUrl(data)
  {
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();

    let loggedUsername =this.common.getUserName()
    this.token =environment.GetAuthenticationToken + ":" +this.common.GetAuthToken()+ ":" + "IT"+ ":"+environment.GetAuthencticationKey+":"+this.common.getSid()+ ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
    set('Authorization', 'basic ' + btoa(this.token));

    return this.http.get<any>(environment.GetItemCategoryListUrl + "?posSubscriptionId=" + data,{headers:this.headers})
    .pipe(map(response => response))    ;
  
   
  }
  GetItemListUrl(data)
  {
    this.GetGeaderdetails();
    return this.http.get<any>(environment.GetItemListUrl + "?posSubscriptionId=" + data,{headers:this.headers})
    .pipe(map(response => response))    ;
  
  }
  GetcatedoryidList(PosSubscriptionId,categoryid)
  {
    this.GetGeaderdetails();
    return this.http.get<any>(environment.GetcatedoryidList+"?posSubscriptionId="+PosSubscriptionId+"&categoryid="+categoryid,{headers:this.headers})
    .pipe(map(response => response))    ;
  
  }
  GetItemCategoryList(data)
  { //this.GetGeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
 
    let loggedUsername =this.common.getUserName()
    this.token =environment.GetAuthenticationToken + ":" +this.common.GetAuthToken()+ ":" + "IT"+ ":"+environment.GetAuthencticationKey+":"+this.common.getSid()+ ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
    set('Authorization', 'basic ' + btoa(this.token));
    return this.http.get<any>(environment.GetItemCategoryList+"?posSubscriptionId="+data,{headers:this.headers})
    .pipe(map(response => response))    ;
  
  }
  GetItemCategoryFilterList(PosSubscriptionId,Fromdate1,todate1,categoryname,taxtype)
  {
    this.GetGeaderdetails();
    return this.http.get<any>( environment.GetItemCategoryFilterList+"?PosSubscriptionId="+PosSubscriptionId+"&fromdate="+Fromdate1+"&todate="+todate1+"&CategoryName="+ 
    categoryname+"&TaxType="+taxtype,{headers:this.headers})
    .pipe(map(response => response))    ;
  
  }
  GetItemList(data)
  {
    // this.GetGeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();

    let loggedUsername =this.common.getUserName()
    this.token =environment.GetAuthenticationToken + ":" +this.common.GetAuthToken()+ ":" + "IT"+ ":"+environment.GetAuthencticationKey+":"+this.common.getSid()+ ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
    set('Authorization', 'basic ' + btoa(this.token));

    return this.http.get<any>(environment.GetItemList+"?posSubscriptionId="+data,{headers:this.headers})
    .pipe(map(response => response))    ;
  
  }
  FilteringitemDetails(data)
  {
    this.GetGeaderdetails();
    // return this.http.get<any>(environment.FilteringitemDetails+"?PosSubscriptionId="+PosSubscriptionId+"&fromdate="+Fromdate1+"&todate="+todate1+"&ItemName="+ 
    //  itemname+"&AlternativeName="+alternativename+"&CategoryName="+Categoryname+"&price="+price+"&PriceType="+priceType +"&symbol="+symbol,{headers:this.headers})
    // .map(response => response);
    return this.http.post<any>(environment.FilteringitemDetails,data,{headers:this.headers})
  }

  GetGeaderdetails()
  {
    let loggedUsername =this.common.getUserName()
    this.token =environment.GetAuthenticationToken + ":" +this.common.GetAuthToken()+ ":" + "IT"+ ":"+environment.GetAuthencticationKey+":"+this.common.getSid();
    this.headers = new HttpHeaders().
    set('Authorization', 'basic ' + btoa(this.token));

  }
}
